export type PaletteCode =
  | 'ocean'
  | 'emerald'
  | 'warm_amber'
  | 'terracotta'
  | 'rose'
  | 'amethyst'
  | 'graphite'
  | 'dynamic'

export interface PaletteDefinition {
  id: PaletteCode
  title: string
  titleEn: string
  subtitleEn: string
  subtitle: string
  c1: string
  c2: string
}

export const PALETTES: PaletteDefinition[] = [
  { id: 'ocean', titleEn: "Ocean Blue", subtitleEn: "Classic sapphire and ocean blue", title: 'Okyanus Mavisi', subtitle: 'Klasik safir ve okyanus mavisi', c1: '#1e3a8a', c2: '#0284c7' },
  { id: 'emerald', titleEn: "Emerald and Sage", subtitleEn: "Restful green and sage tones", title: 'Zümrüt & Adaçayı', subtitle: 'Göz yormayan doğal yeşil tonları', c1: '#064e3b', c2: '#059669' },
  { id: 'warm_amber', titleEn: "Amber and Sand", subtitleEn: "Warm cream and amber tones", title: 'Kehribar & Kum', subtitle: 'Sıcak krem ve kehribar tonları', c1: '#78350f', c2: '#d97706' },
  { id: 'terracotta', titleEn: "Terracotta and Coral", subtitleEn: "Warm earth, coral and stone tones", title: 'Mercan & Kiremit', subtitle: 'Toprak, mercan ve taş tonları', c1: '#7c2d12', c2: '#ea580c' },
  { id: 'rose', titleEn: "Rose and Ruby", subtitleEn: "Ruby and soft rose tones", title: 'Gül Kurusu & Yakut', subtitle: 'Zarif yakut ve gül kurusu', c1: '#881337', c2: '#e11d48' },
  { id: 'amethyst', titleEn: "Amethyst and Lavender", subtitleEn: "Plum, amethyst and lavender tones", title: 'Ametist & Lavanta', subtitle: 'Dingin erik ve ametist tonları', c1: '#4c1d95', c2: '#7c3aed' },
  { id: 'graphite', titleEn: "Graphite and Slate", subtitleEn: "Neutral graphite and slate tones", title: 'Grafit & Antrasit', subtitle: 'Dikkat dağıtmayan nötr grafit', c1: '#1e293b', c2: '#475569' },
  { id: 'dynamic', titleEn: "System (Ocean fallback)", subtitleEn: "Wallpaper colours are unavailable in this web interface", title: 'Sistem (Okyanus)', subtitle: 'Web arayüzünde duvar kâğıdı renkleri kullanılamaz', c1: '#1d4ed8', c2: '#2563eb' },
]

export const PALETTE_KEY = 'scpPalette'
export const VALID_PALETTES: PaletteCode[] = [
  'ocean', 'emerald', 'warm_amber', 'terracotta', 'rose', 'amethyst', 'graphite', 'dynamic'
]

export function loadPalette(): PaletteCode {
  try {
    const raw = typeof localStorage !== 'undefined' ? localStorage.getItem(PALETTE_KEY) : null
    if (raw && (VALID_PALETTES as string[]).includes(raw)) return raw as PaletteCode
  } catch {}
  return 'ocean'
}

/** An explicit personal palette takes precedence over workspace brand colours. */
export function hasExplicitPalette(): boolean {
  try {
    const value = localStorage.getItem(PALETTE_KEY)
    return value !== null && (VALID_PALETTES as string[]).includes(value)
  } catch { return false }
}
